export const INTEGRATION_NAMES = {
  TALABAT: "TALABAT",
  MARSOOL: "MARSOOL",
  YANDEX: "YANDEX",
  STORE: "STORE",
  CAREEM_NOW: "CAREEM_NOW",
  JEEBLY: "JEEBLY",
  SLIDER: "SLIDER",
  DELIVERY_ZONE: "DELIVERY_ZONE",
  LYVE_GLOBAL: "LYVE_GLOBAL",
  IFAST:"IFAST"
};
